import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { tableClass } from './styles';
import { isArray } from '../utils/is';

var Tfoot =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Tfoot, _React$PureComponent);

  var _super = _createSuper2(Tfoot);

  function Tfoot() {
    _classCallCheck(this, Tfoot);

    return _super.apply(this, arguments);
  }

  _createClass(Tfoot, [{
    key: "getTrs",
    value: function getTrs() {
      var _this$props$summary = this.props.summary,
          summary = _this$props$summary === void 0 ? [] : _this$props$summary;

      if (!isArray(summary[0])) {
        summary = [summary];
      }

      var summarys = summary;
      var trs = [];

      for (var i = 0; i < summarys.length; i++) {
        var row = summarys[i];
        trs[i] = [];
        var index = 0;

        for (var j = 0; j < row.length; j++) {
          var item = row[j];
          var nextIndex = index + (item.colSpan || 1);
          trs[i].push(this.renderTd(item, index));
          index = nextIndex;
        }
      }

      return trs;
    }
  }, {
    key: "renderTd",
    value: function renderTd(item, index) {
      var render = item.render,
          _item$colSpan = item.colSpan,
          colSpan = _item$colSpan === void 0 ? 1 : _item$colSpan;
      var columns = this.props.columns;
      var content = render();
      var fixed = {};
      var isLast = index + colSpan - 1 >= columns.length - 1;

      for (var i = 0; i < colSpan; i++) {
        var col = columns[index + i] || {};

        if (col.fixed) {
          fixed["fixed-".concat(col.fixed)] = true;
        }

        if (col.firstFixed) {
          fixed['fixed-first'] = true;
        }

        if (col.lastFixed) {
          fixed['fixed-last'] = true;
        }
      }

      return (
        /*#__PURE__*/
        React.createElement("td", {
          key: index,
          colSpan: colSpan,
          className: tableClass.apply(void 0, _toConsumableArray(Object.keys(fixed)).concat([isLast && 'ignore-right-border']))
        }, content)
      );
    }
  }, {
    key: "render",
    value: function render() {
      var trs = this.getTrs();
      return (
        /*#__PURE__*/
        React.createElement("tfoot", null, trs.map(function (tr, index) {
          return (
            /*#__PURE__*/
            React.createElement("tr", {
              key: index,
              className: tableClass('normal')
            }, tr)
          );
        }))
      );
    }
  }]);

  return Tfoot;
}(React.PureComponent);

export default Tfoot;